// import STORE_CONST from '../consts'

const state = {
  approval: {
    sqlList: [],
    securityList: []
  }
}

const mutations = {
}

const actions = {
}

const getters = {
  approval: state => {
    return state.approval
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/approval.js